<template>
  <div v-if="visible" class="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 max-w-md w-full">
    <div class="bg-white rounded-lg shadow-elevation-3 p-4 flex items-center animate-fade-in" :class="typeClass">
      <i class="fa" :class="iconClass" :style="{ color: iconColor }"></i>
      <span class="ml-3">{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',
  data() {
    return {
      visible: false,
      message: '',
      type: 'success', // success, error, warning, info
      timer: null
    }
  },
  computed: {
    typeClass() {
      switch (this.type) {
        case 'success':
          return 'border-l-4 border-success';
        case 'error':
          return 'border-l-4 border-danger';
        case 'warning':
          return 'border-l-4 border-warning';
        case 'info':
          return 'border-l-4 border-primary';
        default:
          return 'border-l-4 border-success';
      }
    },
    iconClass() {
      switch (this.type) {
        case 'success':
          return 'fa-check-circle';
        case 'error':
          return 'fa-times-circle';
        case 'warning':
          return 'fa-exclamation-circle';
        case 'info':
          return 'fa-info-circle';
        default:
          return 'fa-check-circle';
      }
    },
    iconColor() {
      switch (this.type) {
        case 'success':
          return '#52C41A';
        case 'error':
          return '#FF4D4F';
        case 'warning':
          return '#FAAD14';
        case 'info':
          return '#165DFF';
        default:
          return '#52C41A';
      }
    }
  },
  methods: {
    show({ message, type = 'success', duration = 3000 }) {
      this.message = message;
      this.type = type;
      this.visible = true;
      
      // 清除之前的定时器
      if (this.timer) {
        clearTimeout(this.timer);
      }
      
      // 设置新的定时器
      this.timer = setTimeout(() => {
        this.visible = false;
      }, duration);
    },
    hide() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>